import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { RecaptchaAction, RecaptchaData } from '@app/core/recaptcha/recaptcha-commons';

@Injectable({
  providedIn: 'root',
})
export class ReCaptchaService implements OnDestroy {
  private readonly baseApiKey = environment.recaptchaBaseKey;
  private readonly checkboxApiKey = environment.recaptchaCheckboxKey;
  private scriptTag: HTMLScriptElement | null = null;

  constructor() {
    this.init();
  }

  public ngOnDestroy(): void {
    this.scriptTag?.remove();
    this.scriptTag = null;
  }

  private init(): void {
    this.scriptTag = document.createElement('script');
    this.scriptTag.innerHTML = '';
    this.scriptTag.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.baseApiKey}`;
    document.head.appendChild(this.scriptTag);
  }

  public generateToken(actionName: RecaptchaAction): Observable<RecaptchaData> {
    const apiKey = this.baseApiKey;
    return new Observable(subscriber => {
      grecaptcha.enterprise.ready(async () => {
        try {
          const token = await grecaptcha.enterprise.execute(apiKey, { action: actionName });
          subscriber.next({
            token,
            apiKey,
          });
          subscriber.complete();
        } catch (e) {
          subscriber.error(e);
        }
      });
    });
  }

  public createCheckbox(container: HTMLElement): Observable<RecaptchaData> {
    const apiKey = this.checkboxApiKey;
    return new Observable<RecaptchaData>(subscriber => {
      grecaptcha.enterprise.ready(() => {
        grecaptcha.enterprise.render(container, {
          sitekey: apiKey,
          callback: (token: string) => {
            subscriber.next({
              token,
              apiKey,
            });
            subscriber.complete();
          },
        });
      });
    });
  }
}
